/*
  Bewertungen live aus REVIEWS.io, shopweit gleich: alle Shop- und Produktbewertungen zusammen,
  dieselbe Zahl wie im REVIEWS.io-Karussell. Liquid rendert vorab die Produktwerte als Rueckfall,
  dieses Skript ersetzt sie durch den Gesamtstand.

  Ziele im Markup:
  - [data-reviews-live="avg"]    Durchschnitt, z. B. 4,79
  - [data-reviews-live="count"]  Anzahl, z. B. 364
  - [data-reviews-live-stars]    Sterne ueber --rating und --rating-decimal
  - [data-reviews-live-label]    aria-label "4,79 von 5 Sternen"
  - .ruk_rating_snippet          Platz des frueheren REVIEWS.io-Snippets unter dem Produkttitel
*/
(function () {
  var KEY = 'sniffys-reviews-live-v1';
  var TTL = 30 * 60 * 1000;
  var URL = 'https://api.reviews.io/timeline/data?type=store_review&store=sniffys.de&per_page=1&page=1&include_product_reviews=1&must_have_comments=true&sku=&lang=de';

  function cached() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY));
      if (c && Date.now() - c.t < TTL && c.count > 0) return c;
    } catch (e) {}
    return null;
  }

  function store(d) {
    try { sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
  }

  function fmt(n) {
    return n.toFixed(2).replace('.', ',');
  }

  function stars(avg) {
    var decimal = avg % 1;
    var half = decimal > 0.7 ? 1 : decimal >= 0.3 ? 0.5 : 0;
    return { rating: Math.floor(avg), decimal: half };
  }

  function apply(d) {
    var avg = fmt(d.avg);
    var s = stars(d.avg);
    var label = avg + ' von 5 Sternen';

    document.querySelectorAll('[data-reviews-live="avg"]').forEach(function (el) { el.textContent = avg; });
    document.querySelectorAll('[data-reviews-live="count"]').forEach(function (el) { el.textContent = d.count; });
    document.querySelectorAll('[data-reviews-live-stars]').forEach(function (el) {
      el.style.setProperty('--rating', s.rating);
      el.style.setProperty('--rating-decimal', s.decimal);
    });
    document.querySelectorAll('[data-reviews-live-label]').forEach(function (el) { el.setAttribute('aria-label', label); });

    document.querySelectorAll('.ruk_rating_snippet, .reviews-live-snippet').forEach(function (el) {
      // Klasse tauschen, damit das REVIEWS.io-App-Embed den Platz nicht wieder mit Produktzahlen fuellt
      el.classList.remove('ruk_rating_snippet');
      el.classList.add('reviews-live-snippet');
      el.innerHTML =
        '<div class="product__rating flex items-center gap-2">' +
          '<span class="rating text-lg leading-none" role="img" aria-label="' + label + '">' +
            '<span aria-hidden="true" class="rating-star" style="--rating: ' + s.rating + '; --rating-max: 5; --rating-decimal: ' + s.decimal + ';"></span>' +
          '</span>' +
          '<span class="rating-text text-sm leading-none" aria-hidden="true">' + avg + '</span>' +
          '<span class="rating-count text-sm leading-none">' + d.count + ' Bewertungen</span>' +
        '</div>';
    });
  }

  function run() {
    var c = cached();
    if (c) { apply(c); return; }
    fetch(URL, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var st = j && j.stats;
        var count = st ? parseInt(st.review_count, 10) : 0;
        var avg = st ? parseFloat(st.average_rating) : 0;
        if (!count || !avg) return;
        var d = { t: Date.now(), count: count, avg: avg };
        store(d);
        apply(d);
      })
      .catch(function () {});
  }

  // Alte Bewertungen tragen noch den Namen der Gratis-Kopien vom frueheren Geschenk-App ("... (100% off)").
  // Der Katalog ist korrigiert, die gespeicherten Namen an den Bewertungen nicht. Hier den Zusatz entfernen.
  var OFF = /\s*\(100% off\)/g;
  function cleanNames(root) {
    if (!root || !root.textContent || root.textContent.indexOf('100% off') === -1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('100% off') !== -1) n.nodeValue = n.nodeValue.replace(OFF, '');
    }
  }
  function watchNames() {
    cleanNames(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            cleanNames(node);
            // nachgeladene Karten (Mega-Menue, Filter, Quick View) ebenfalls auf den Gesamtstand setzen
            if (node.querySelector && (node.matches('[data-reviews-live], .ruk_rating_snippet') || node.querySelector('[data-reviews-live], .ruk_rating_snippet'))) {
              var c = cached();
              if (c) apply(c);
            }
          }
          else if (node.nodeType === 3 && node.nodeValue.indexOf('100% off') !== -1) node.nodeValue = node.nodeValue.replace(OFF, '');
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchNames);
  else watchNames();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', function () {
    var c = cached();
    if (c) apply(c);
  });
})();
